import { render } from "./BuildBundleTestCard.vue?vue&type=template&id=0966a1cc&scoped=true"
import script from "./BuildBundleTestCard.vue?vue&type=script&lang=js"
export * from "./BuildBundleTestCard.vue?vue&type=script&lang=js"

import "./BuildBundleTestCard.vue?vue&type=style&index=0&id=0966a1cc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0966a1cc"]])

export default __exports__